<template>
  <v-list-item>
    <v-list-item-action>
      <v-icon>fa-search</v-icon>
    </v-list-item-action>
    <v-list-item-content class="py-0">
      <v-menu offset-x right @input="toggleMenu" disable-keys>
        <template v-slot:activator="{ on }">
          <v-text-field v-model="search" v-on="on"></v-text-field>
        </template>
        <v-list class="fh-menu-scroll">
          <template v-if="!isEmpty">
            <v-list-item
              v-for="result in filteredOptions"
              :key="result.idSubconcepto"
              dense
              :to="{
                name: 'Movimiento',
                params: {
                  conceptoSlug: slugify(result.concepto.nombre),
                  idSubconcepto: result.idSubconcepto,
                },
              }"
            >
              <v-list-item-title
                >{{ result.concepto.nombre
                }}<v-icon small left right>fa-angle-right</v-icon
                >{{ result.nombre }}</v-list-item-title
              >
            </v-list-item>
          </template>
        </v-list>
      </v-menu>
    </v-list-item-content>
  </v-list-item>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import ConfiguracionRepository from "@/services/ConfiguracionRepository";
import Vue from "vue";

export default {
  name: "FhGanaderiaMenuSearch",
  data() {
    return {
      search: "",
      listaSubconceptos: [],
    };
  },
  computed: {
    ...mapState("conceptos", ["conceptos", "subConceptos"]),
    ...mapGetters("conceptos", ["listaFiltradaConceptos"]),
    ...mapState("session", ["isRestored"]),
    filteredOptions() {
      return this.listaSubconceptos.filter((sub) => {
        if (this.search === "") return [];
        if (sub.nombre && sub.concepto) {
          return (
            sub.nombre.toLowerCase().includes(this.search.toLowerCase()) ||
            sub.concepto.nombre
              .toLowerCase()
              .includes(this.search.toLowerCase())
          );
        }
      });
    },
    isEmpty() {
      return (
        Array.isArray(this.filteredOptions) && this.filteredOptions.length === 0
      );
    },
  },
  methods: {
    ...mapActions("conceptos", [
      "fetchListaConceptos",
      "fetchListaSubConceptos",
    ]),
    toggleMenu(toggle) {
      if (!toggle) {
        this.search = "";
      }
    },
    slugify(concepto) {
      return Vue.filter("fhSlug")(concepto);
    },
  },
  async created() {
    // To prevent a race condition when session isn't restored yet
    while (!this.isRestored) {
      await this.$sleep(10);
    }

    // await this.fetchListaConceptos()
    // await this.fetchListaSubConceptos()
    if (this.subConceptos.length === 0) {
      this.listaSubconceptos =
        await ConfiguracionRepository.listaSubConceptos();
    }
  },
};
</script>

<style scoped>
.fh-menu-scroll {
  overflow-y: auto;
  max-height: 90vh;
}
</style>
